import { Clickable, Col, Icon, Row, Sidepanel, Spinner2, Text } from 'components';
import { Api, theme } from 'lib';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { SideBarItem } from 'screens/Browse/components';

const AllUsers = ({ visible, closeModal, data, type, team }) => {
  const [filtered, setFiltered] = useState(null),
    { removedSuggestions, following, _id } = useSelector((state) => state.user) || {},
    { isMobile } = useSelector((state) => state.appState),
    { t } = useTranslation(),
    dispatch = useDispatch(),
    navigate = useNavigate(),
    fetching = useRef(false),
    users = useRef([]),
    endReached = useRef(false);

  useEffect(() => {
    if (!visible) return;

    team?._id ? fetchTeamData() : fetchData();
  }, [visible]);

  async function fetchData() {
    if (!type && !team) return;
    if (fetching.current || endReached.current) return;

    fetching.current = true;

    const res = await Api.post('/browse/getMoreUsers', {
      type,
      skip: users.current.length
    });

    if (!res) return (fetching.current = false);
    if (!res.length) return (endReached.current = true);

    const newUsers = [...users.current, ...res];
    users.current = newUsers;

    const newFiltered = newUsers.filter((x) => {
      if (!x?._id) return false;

      const hasName = x.name;
      const isntSelf = team ? true : x._id !== _id;

      return hasName && isntSelf;
    });

    setFiltered(newFiltered);
    fetching.current = false;
  }

  async function fetchTeamData() {
    const res = await Api.post('/users/getTeamMembers', { teamId: team._id });
    if (!res) return;

    setFiltered(res);
  }

  return (
    <Sidepanel
      visible={visible}
      contentId={type ? `${type}-scroll` : ''}
      onContentEndReached={!team && fetchData}
      closeModal={closeModal}
      wid={500}
      headerHt={88}
      title={
        <Row
          between
          center
          noFlex
          ht={isMobile ? '44px' : '88px'}
          pad={isMobile ? '16px' : '0 24px'}
        >
          <Text h2>
            {team
              ? team.name
              : type === 'fan'
                ? t('browse.allFans')
                : type === 'team'
                  ? t('browse.allTeams')
                  : t('browse.allAthletes')}
          </Text>

          <Clickable onClick={closeModal}>
            <Icon type="close" col={theme.GREY_60} dimensions={14} />
          </Clickable>
        </Row>
      }
    >
      <Col wid="100%" marg="0 0 24px">
        {!filtered?.length ? (
          <Spinner2 />
        ) : (
          Array.isArray(filtered) &&
          filtered?.map((x, i) => (
            <SideBarItem
              key={i}
              item={x}
              navigate={navigate}
              // subtitleText={subtitleText}
              // removeSuggestion={removeSuggestion}
              allUsers={!!type}
            />
          ))
        )}
      </Col>
    </Sidepanel>
  );
};

export default AllUsers;
